import { LitElement } from "lit";
export { html, render } from "lit";
export { ifDefined } from "lit/directives/if-defined.js";
export { unsafeHTML } from "lit/directives/unsafe-html.js";

/** A Lit element with some helper functions that can be styled externally */
export class UnshadowedElement extends LitElement {
    /** The custom element's html name (must be overridden) */
    static elementName() {
        throw new Error("UnshadowedElement must define an elementName()");
    }
    /** Registers the custom element on the page */
    static Register() {
        if (!customElements.get(this.elementName())) {
            customElements.define(this.elementName(), this);
        }
    }
    // Don't use shadow DOM, because in this project we style everything externally
    createRenderRoot() {
        return this;
    }
}
